export default function Django_Add_Test_View() {
  return <div>Django_Add_Test_View Component</div>;
}
